(ns frontend.view.modals.single-reference-relationship.events)

(defn form-ready? [state]
  (let [{:keys [:target-id :new-option]} @state]
    (or target-id new-option)))

